export const REGISTRADO = 1;
export const EMITIDO = 2;
export const RECHAZADO = 3;
export const ANULADO = 4;